import { createI18n } from 'vue-i18n';
import EnglishTranslations from '@/lang/en.json';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';
import { logStatsigTranslationMissingKey } from '@/tracking/statsig/general.functions';

const messages = {
    en: EnglishTranslations,
};

const numberFormats = {
    sv: {
        currency: {
            style: 'currency' as const,
            currency: 'sek',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
    },
    en: {
        currency: {
            style: 'currency' as const,
            currency: 'gbp',
        },
    },
};

type KnownLanguage = keyof typeof numberFormats;

export const i18n = createI18n({
    messages,
    locale: getCurrentMarketSpecs().locale,
    fallbackLocale: 'en',
    numberFormats,
    globalInjection: true,
    legacy: false,
    missingWarn: false,
    missing: logStatsigTranslationMissingKey,
});

function setI18nLanguage(lang: KnownLanguage): KnownLanguage {
    (i18n.global.locale as any).value = lang;
    return lang;
}

export async function loadLanguageAsync(language: string): Promise<KnownLanguage> {
    const languageFile = language === 'da' ? 'dk' : language;

    try {
        const msgs = await import(`./lang/${languageFile}.json`);
        i18n.global.setLocaleMessage(language, msgs.default);
        return setI18nLanguage(language as KnownLanguage);
    } catch {
        // Default to English if language file doesn't exist
        const msgs = await import(`./lang/en.json`);
        i18n.global.setLocaleMessage(language, msgs.default);
        return setI18nLanguage(language as KnownLanguage);
    }
}
